export const replacer = (str: string, matches: Record<string, unknown>) => {
  return str.replace(/{\w+}/g, (substr) => {
    const prop = substr.slice(1, -1)
    return `${matches[prop] ?? ''}`
  })
}
